import { TypographyStyleOptions } from '@mui/material/styles/createTypography';

export const fontFamily =
  '"Metropolis", "Red Hat Display", "Roboto", "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif';

export const typographyPalette = {
  h1: {
    fontSize: '96px',
    textDecoration: 'none',
    fontFamily,
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-1.5px',
    lineHeight: '112.032px',
    textTransform: 'none'
  } satisfies TypographyStyleOptions,
  h2: {
    fontSize: '60px',
    textDecoration: 'none',
    fontFamily,
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-0.5px',
    lineHeight: '72px',
    textTransform: 'none'
  } satisfies TypographyStyleOptions,
  h3: {
    fontSize: '48px',
    textDecoration: 'none',
    fontFamily,
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '0px',
    lineHeight: '56.016px',
    textTransform: 'none'
  } satisfies TypographyStyleOptions,
  h4: {
    fontSize: '34px',
    textDecoration: 'none',
    fontFamily,
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '0.25px',
    lineHeight: '41.99px',
    textTransform: 'none'
  } satisfies TypographyStyleOptions,
  h5: {
    fontSize: '24px',
    textDecoration: 'none',
    fontFamily,
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '0px',
    lineHeight: '32.016px',
    textTransform: 'none'
  } satisfies TypographyStyleOptions,
  h6: {
    fontSize: '20px',
    textDecoration: 'none',
    fontFamily,
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '0.15px',
    lineHeight: '32px',
    textTransform: 'none'
  } satisfies TypographyStyleOptions,
  body1: {
    fontSize: '16px',
    textDecoration: 'none',
    fontFamily,
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '0.15px',
    lineHeight: '24px',
    textTransform: 'none'
  } satisfies TypographyStyleOptions,
  body1Bold: {
    fontSize: '16px',
    textDecoration: 'none',
    fontFamily,
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '0.15px',
    lineHeight: '24px',
    textTransform: 'none'
  } satisfies TypographyStyleOptions,
  body2: {
    fontSize: '14px',
    textDecoration: 'none',
    fontFamily,
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '0.17px',
    lineHeight: '20.02px',
    textTransform: 'none'
  } satisfies TypographyStyleOptions,
  subtitle1: {
    fontSize: '16px',
    textDecoration: 'none',
    fontFamily,
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '0.15px',
    lineHeight: '28px',
    textTransform: 'none'
  } satisfies TypographyStyleOptions,
  subtitle2: {
    fontSize: '14px',
    textDecoration: 'none',
    fontFamily,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '0.1px',
    lineHeight: '21.98px',
    textTransform: 'none'
  } satisfies TypographyStyleOptions,
  overline: {
    fontSize: '12px',
    textDecoration: 'none',
    fontFamily,
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '1px',
    lineHeight: '31.92px',
    textTransform: 'uppercase'
  } satisfies TypographyStyleOptions,
  caption: {
    fontSize: '12px',
    textDecoration: 'none',
    fontFamily,
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '0.4px',
    lineHeight: '19.92px',
    textTransform: 'none'
  } satisfies TypographyStyleOptions,
  alert: {
    title: {
      fontSize: '16px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 500,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.15px',
      lineHeight: '24px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions,
    description: {
      fontSize: '14px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 400,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.15px',
      lineHeight: '20.02px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions
  },
  avatar: {
    initials: {
      fontSize: '16px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 500,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.14px',
      lineHeight: '20px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions
  },
  badge: {
    label: {
      fontSize: '12px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 500,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.14px',
      lineHeight: '20px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions
  },
  bottomNavigation: {
    activeLabel: {
      fontSize: '14px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 400,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.4px',
      lineHeight: '23.24px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions
  },
  button: {
    large: {
      fontSize: '15px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 500,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.46px',
      lineHeight: '26px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions,
    medium: {
      fontSize: '14px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 500,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.4px',
      lineHeight: '24px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions,
    small: {
      fontSize: '13px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 500,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.46px',
      lineHeight: '22px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions
  },
  chip: {
    label: {
      fontSize: '13px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 500,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.16px',
      lineHeight: '18px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions
  },
  datepicker: {
    currentMonth: {
      fontSize: '16px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 400,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.15px',
      lineHeight: '24px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions
  },
  input: {
    label: {
      fontSize: '12px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 400,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.15px',
      lineHeight: '12px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions,
    value: {
      fontSize: '16px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 400,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.15px',
      lineHeight: '24px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions,
    helper: {
      fontSize: '12px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 400,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.4px',
      lineHeight: '19.92px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions
  },
  list: {
    subheader: {
      fontSize: '14px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 500,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.1px',
      lineHeight: '48px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions
  },
  menu: {
    itemDefault: {
      fontSize: '16px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 400,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.15px',
      lineHeight: '24px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions,
    itemDense: {
      fontSize: '14px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 400,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.17px',
      lineHeight: '24px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions
  },
  table: {
    header: {
      fontSize: '14px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 500,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.17px',
      lineHeight: '24px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions
  },
  tooltip: {
    label: {
      fontSize: '10px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 500,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0px',
      lineHeight: '14px',
      textTransform: 'none'
    } satisfies TypographyStyleOptions
  },
  dataGrid: {
    aggregationColumnHeaderLabel: {
      fontSize: '12px',
      textDecoration: 'none',
      fontFamily,
      fontWeight: 500,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.15px',
      lineHeight: '12px',
      textTransform: 'uppercase'
    } satisfies TypographyStyleOptions
  }
};
